import app from "@/main";

function getPersistedUserStatus() {
  const db = app.config?.globalProperties?.$DbStorage;
  if (!db || typeof db.getItem !== "function") {
    return null;
  }
  return db.getItem("rocketfuel_status");
}

export default function isAuth({ next, store }) {
  const storedStatus = getPersistedUserStatus();
  const effectiveStatus =
    storedStatus !== null && storedStatus !== undefined && storedStatus !== ""
      ? storedStatus
      : store.getters["auth/userStatus"];
  const hasUserStatus = (() => {
    const n = Number(effectiveStatus);
    if (!Number.isNaN(n)) return n !== 0;
    return !!effectiveStatus;
  })();

  if (store.getters["auth/isAuth"] && !hasUserStatus) {
    return next({
      name: "EmailConfirm",
    });
  }
  if (store.getters["auth/isAuth"] && hasUserStatus) {
    return next({
      name: "Payment",
    });
  }

  return next();
}
